import Bowser from 'bowser';
import ReactGA from 'react-ga';

export const isRecordingSupported = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const notSupported = browser.satisfies({
    macos: {
      safari: '<15.0.0',
    },
  });

  if (notSupported) {
    ReactGA.event({
      category: 'Browser support',
      action: 'Record video',
      label: 'UNSUPPORTED_BROWSER',
      nonInteraction: true
    });

    return false;
  } else {
    ReactGA.event({
      category: 'Browser support',
      action: 'Record video',
      label: 'SUPPORTED_BROWSER',
      nonInteraction: true
    });

    return true;
  }
};



// WEBPACK FOOTER //
// ./src/helpers/supportedFeatureHelper.js